import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(array: any[], field: string, value: string) {
    // Is loading if array is not defined
    if (!array) {
      return [];
    }
    if (!value) {
      return array;
    }
    return array.filter(item => item[field]?.toLowerCase().includes(value.toLowerCase()));
  }

}
